import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function SolutionIntro() {
  return <section className="relative overflow-hidden bg-navy-900 py-12 md:py-24" data-id="element-193">
      <div className="pointer-events-none absolute inset-0 bg-stadium-glow opacity-50" data-id="element-194" />
      <div className="container relative z-10 mx-auto px-4" data-id="element-195">
        <div className="max-w-4xl mx-auto text-center" data-id="element-196">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-197">
            <h2 className="mb-4 font-anton text-3xl uppercase tracking-wide text-gold-500 sm:text-4xl md:text-6xl" data-id="element-198">
              THE SOLUTION YOU&apos;VE BEEN WAITING FOR
            </h2>
            <h3 className="mb-8 font-oswald text-xl uppercase tracking-wide text-white sm:text-2xl sm:tracking-widest md:mb-12 md:text-3xl" data-id="element-199">
              A COMPLETE 6-VOLUME COACHING SYSTEM
            </h3>
            <p className="mb-6 text-base font-medium leading-7 text-gray-300 md:mb-12 md:text-xl" data-id="element-200">
              Designed specifically for basketball coaches.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="relative mb-8 md:mb-16" data-id="element-201">
            <div className="absolute -inset-4 rounded-full bg-gold-500/10 blur-2xl" data-id="element-202" />
            <img src="https://cdn.magicpatterns.com/uploads/uX49a1hWSoJtApdNmg3hsK/ChatGPT_Image_19_jun_2026,_01_20_58.webp" alt="Basketball Ready: System 365 coaching system" loading="lazy" decoding="async" className="relative mx-auto h-auto w-full max-w-3xl rounded-xl border border-navy-700/50 shadow-2xl" data-id="element-203" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="prose prose-invert mx-auto text-base leading-7 text-gray-300 md:prose-lg" data-id="element-204">
            <p className="mb-4 text-base font-medium leading-7 text-white md:mb-6 md:text-2xl" data-id="element-205">
              BASKETBALL READY: SYSTEM 365 is much more than a coaching manual.
            </p>
            <p className="mb-8 leading-relaxed" data-id="element-206">
              It is a complete coaching operating system that gives you
              structured player development, ready-to-use practices, tactical
              progression, season planning tools, game-day resources, and team
              culture frameworks.
            </p>
            <div className="flex flex-col justify-center gap-2 font-oswald text-base uppercase tracking-normal text-gold-400 md:flex-row md:gap-8 md:text-xl md:tracking-wider" data-id="element-207">
              <span data-id="element-208">✓ Everything organized.</span>
              <span data-id="element-209">✓ Everything structured.</span>
              <span data-id="element-210">✓ Everything ready to use.</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}